module.exports = __webpack_public_path__ + "img/germany-cerebrovascular-disease-male.9b960664.png";